import {
  COMMON_GET_BRANCH_OFFICE_BEGIN,
  COMMON_GET_BRANCH_OFFICE_SUCCESS,
  COMMON_GET_BRANCH_OFFICE_FAILURE,
  COMMON_GET_BRANCH_OFFICE_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { REACT_APP_API } from '../../../common/config'

export function getBranchOffice(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_BRANCH_OFFICE_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios(`${REACT_APP_API}/branchoffices/all`)
      doRequest.then(
        (res) => {
          dispatch({
            type: COMMON_GET_BRANCH_OFFICE_SUCCESS,
            data: res.data.data,
          })
          resolve(res.data.data)
        },
        (err) => {
          dispatch({
            type: COMMON_GET_BRANCH_OFFICE_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

export function dismissGetBranchOfficeError() {
  return {
    type: COMMON_GET_BRANCH_OFFICE_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_BRANCH_OFFICE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getBranchOfficePending: true,
        getBranchOfficeError: null,
        branchOffices: null,
      }

    case COMMON_GET_BRANCH_OFFICE_SUCCESS:
      // The request is success
      return {
        ...state,
        getBranchOfficePending: false,
        getBranchOfficeError: null,
        branchOffices: action.data,
      }

    case COMMON_GET_BRANCH_OFFICE_FAILURE:
      // The request is failed
      return {
        ...state,
        getBranchOfficePending: false,
        getBranchOfficeError: action.data.error,
        branchOffices: null,
      }

    case COMMON_GET_BRANCH_OFFICE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getBranchOfficeError: null,
      }

    default:
      return state
  }
}
